export default "__VITE_ASSET__CIZX8$oC__"